const { createTheme } = require('@mui/material');

export const theme = createTheme({
  direction: 'rtl',
  palette: {
    primary: {
      main: '#60c2a4',
      contrastText: '#fff',
    },
    secondary: {
      main: '#605cb8',
      contrastText: '#fff',
    },
    text: {
      primary: '#202e39',
      secondary: '#777',
    },
  },
  typography: {
    fontFamily: 'IranSans',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          minWidth: '160px',
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: 'small',
      },
    },
  },
});
